export class TextInput {

    constructor (private textContainer:JQuery) {
        textContainer.find('.form-text-clear').on("click",()=>this.clickEvent());
    }

    private clickEvent() {
        this.textContainer.find("input").val("").focus().trigger("input").trigger("clear");
    }

}

export {};